import axios from 'axios'

export default {
  state: {
    links: [],
  },
  getters: {
    Links(state) {
      return state.links.links
    },
  },
  mutations: {
    updateLinks(state, links) {
      state.links = links
    },
  },
  actions: {
    fetchSocialLinks(ctx) {
      return axios({
        method: 'GET',
        url: 'api/auth/login/links/',
      })
        .then((response) => {
          ctx.commit('updateLinks', response.data)
          return true
        })
        .catch((error) => {
          console.error(error)
          return false
        })
    },
  },
}
